export const groupByAlertId = (data) => {
  const result = {};
  data.forEach((d) => {
    if (result[d.alertId]) result[d.alertId].push(d);
    else result[d.alertId] = [d];
  });
  return Object.values(result);
};
